import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AbstractProfileValidator} from "@biletix/features/performance/components/performance-page/ticket-content-viewport/ticket-selection-content/ticket-profile-validation/base/abstract-profile-validator";
import {FieldConfig} from "@biletix/core/models/base/field-config.model";
import {EventProfileType} from "@biletix/core/common/enums/event-profile-type.enum";
import {CreditCardTypeService} from "@biletix/core/services/credit-card-type.service";

@Component({
    standalone: false,
    selector: 'btx-credit-card-profile-validator',
    templateUrl: './credit-card-profile-validator.component.html',
    styleUrls: ['./credit-card-profile-validator.component.scss']
})
export class CreditCardProfileValidatorComponent extends AbstractProfileValidator implements OnInit {

    maskedCardNumber: string = '0000 00 ** **** ****';

    creditCardValidationForm!: FormGroup;

    validationFieldConfig: FieldConfig | any;

    isDiscountApplied: boolean = false;

    eventProfileType = EventProfileType;

    constructor(fb: FormBuilder,
                private creditCardTypeService: CreditCardTypeService) {
        super(fb);
    }

    ngOnInit(): void {

        //
        this.validationFieldConfig = this.validationFieldConfigs[0];

        //bin number validate
        if (this.validationFieldConfig) {
            this.validationFieldConfig.validations.push({
                message: "shared.validation.errors.minLength",
                validator: Validators.minLength(6),
                name: 'minlength'
            });
            this.initializeCreditCardForm();
        }
    }

    initializeCreditCardForm() {
        this.creditCardValidationForm = this.addValidationFieldItems(this.validationFieldConfig)!;
    }


    onValidateProfile() {
        if (this.creditCardValidationForm.invalid || this.isDiscountApplied) {
            this.creditCardValidationForm.markAllAsTouched();
            return;
        }


        //TODO: Credit cart profil doğrulama işlemi güncellenecek.Test amaçlı eklendi.
        let formValue = this.creditCardValidationForm.value;
        this.creditCardTypeService
            .findByBinNumber(formValue.value).pipe(this.takeUntilDestroy())
            .subscribe(response => {

                    if (response && response.data) {
                        this.isDiscountApplied = !this.isDiscountApplied;
                        this.creditCardValidationForm.get(this.validationFieldConfig.name)?.disable();
                    } else {
                        this.isDiscountApplied = false;
                        this.creditCardValidationForm.controls[this.validationFieldConfig.name]?.setErrors(
                            {inValidCardNo: true});
                    }
                }
            )
    }


    //TODO: Düzenlenecek.
    isMaskedCardNumberVisible(): boolean {
        return true;
    }

}
